import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useGuest } from "@/context/GuestContext";
import BrandLogo from "@/components/BrandLogo";
import { CheckCircle2, Star } from "lucide-react";

export default function GuestReviewPage() {
  const { guest, loading } = useGuest();
  const nav = useNavigate();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    http.get("/public/review-info").then((r) => setInfo(r.data)).catch(() => setInfo({ enabled: false }));
  }, []);

  if (loading || !info) return null;
  if (!info.enabled) { nav("/guest/feedback"); return null; }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "var(--surface)" }}>
      <div className="max-w-md w-full text-center fadein">
        <BrandLogo className="h-14 mx-auto mb-6" />
        <span className="inline-flex w-16 h-16 rounded-full items-center justify-center mb-5" style={{ background: "var(--pine-subtle)" }}>
          <CheckCircle2 size={34} style={{ color: "var(--pine)" }} />
        </span>
        <div className="eyebrow mb-2" style={{ color: "var(--pine)" }} data-testid="review-checkout-done">Checkout Complete</div>
        <h1 className="font-serif text-4xl mb-1" data-testid="review-thank-you">
          Thank you{guest ? `, ${guest.full_name.split(" ")[0]}` : ""}
        </h1>
        <p className="text-sm mb-6" style={{ color: "var(--muted)" }}>Thank you for staying with us. We hope you enjoyed your time at Freebird Nest.</p>

        <div className="card" data-testid="review-card">
          <div className="eyebrow mb-3">How was your stay?</div>
          <p className="text-sm mb-5 leading-relaxed" style={{ color: "var(--muted)" }}>
            If you have a moment, we'd love to hear about your experience. Your feedback helps future guests discover Freebird Nest.
          </p>
          {info.qr_image_url && (
            <div className="hidden sm:block mb-5">
              <div className="inline-block p-6 rounded-2xl" style={{ background: "#fff", border: "1px solid var(--border)" }}>
                <img src={info.qr_image_url} alt="Scan to review Freebird Nest on Google" className="w-44 h-44 object-contain" data-testid="review-qr" />
              </div>
              <div className="text-xs mt-2" style={{ color: "var(--muted)" }}>Scan to review us on Google</div>
            </div>
          )}
          <a href={info.url} target="_blank" rel="noopener noreferrer" data-testid="review-google-btn"
            className="btn-primary w-full inline-flex items-center justify-center gap-2">
            <Star size={16} /> Leave a Google Review
          </a>
          <Link to="/guest/feedback" data-testid="review-maybe-later" className="block text-sm mt-4 underline" style={{ color: "var(--muted)" }}>
            Maybe later
          </Link>
        </div>
        <p className="serif-quote text-lg mt-6" style={{ color: "var(--pine)" }}>"Come as a Guest. Leave as Family."</p>
      </div>
    </div>
  );
}
